import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TenantFilterDto } from '@artemis-software/wr-api';
import { emergencyContactTypeTranslations } from '@shared/pipes/emergency-contact-type-translation.pipe';

@Component({
  standalone: false,
  selector: 'wr-emergency-contacts-tab',
  templateUrl: './emergency-contacts-tab.component.html',
})
export class EmergencyContactsTabComponent {
  @Input({ required: true }) form!: FormGroup;

  protected readonly TenantFilterTypeEnum = TenantFilterDto.TypeEnum;
  protected readonly translations = emergencyContactTypeTranslations;
}
